export const emptyData = {
	object: 'value',
	document: {
		object: 'document',
		data: {},
		nodes: [
			{
				object: 'block',
				type: 'paragraph',
				data: {},
				nodes: [
					{
						object: 'text',
						text: '',
					},
				],
			},
		],
	},
}

export const placeholderData = {
	object: 'value',
	document: {
		object: 'document',
		data: {},
		nodes: [
			{
				object: 'block',
				type: 'paragraph-placeholder',
				data: {},
				nodes: [
					{
						object: 'text',
						text:
							'––––– –– ––– ––––––– –––––– –– –– –––––– –– –––––––– ––– –––– –––– ––––––––––– ––– ––– –– ––– ––––– ––––––––––– –– –––––––– ––––– –– –––– –––– –––––– –––––––––',
					},
				],
			},
			{
				object: 'block',
				type: 'paragraph-placeholder',
				data: {},
				nodes: [
					{
						object: 'text',
						text: `• ––––– –– ––– ––––––– 
• ––––– ––
• ––––– –– –––`,
					},
				],
			},
			{
				object: 'block',
				type: 'heading-placeholder',
				data: {},
				nodes: [
					{
						object: 'text',
						text: 'Mein erster Wiki-Eintrag',
					},
				],
			},
			{
				object: 'block',
				type: 'paragraph-placeholder',
				data: {},
				nodes: [
					{
						object: 'text',
						text:
							'––––– –– ––– ––––––– –––––– –– –– –––––– –– –––––––– ––– –––– –––– ––––––––––– ––– ––– –– ––– ––––– ––––––––––– –– –––––––– ––––– –– –––– –––– –––––– ––––––––– –––– ––––– ––––– ––––––––––––––– ––– ––––––– –––––– –– –– – –––––– –– –––––– – ––– –– –– –––––– –– ––––––––– ',
					},
				],
			},
		],
	},
}
